import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faGavel, faEnvelope, faPhone, faExclamationTriangle, faUtensils, faCalendarAlt, faTruck, faStar, faCreditCard, faLock, faTag, faFileAlt } from '@fortawesome/free-solid-svg-icons';

const Terminos = () => {
  const [openSection, setOpenSection] = useState(null);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleSection = (sectionId) => {
    setOpenSection(openSection === sectionId ? null : sectionId);
  };

  const termssections = [
    {
      id: 'aceptacion',
      title: 'Aceptación de los Términos',
      content: (
        <div className="space-y-4">
          <p className="font-sans text-lg text-gray-700 leading-relaxed">
            Al utilizar nuestros servicios, ya sea visitando nuestro restaurante, realizando reservas, 
            realizando pedidos o navegando por nuestro sitio web, usted acepta estos Términos y Condiciones 
            en su totalidad. Si no está de acuerdo con alguna parte de estos términos, por favor no utilice nuestros servicios.
          </p>
          <p className="font-sans text-lg text-gray-700 leading-relaxed">
            Estos términos constituyen un acuerdo legal vinculante entre usted y ADASTRA Restaurant.
          </p>
          <div className="bg-green-50 p-6 rounded-xl border-l-4 border-green-600">
            <p className="font-sans text-base text-green-800 font-medium">
              <FontAwesomeIcon icon={faGavel} className="mr-2" />
              Al continuar, confirma que ha leído, entendido y acepta cumplir con estos términos.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'servicios',
      title: 'Descripción de Nuestros Servicios',
      content: (
        <div className="space-y-6">
          <p className="font-sans text-lg text-gray-700 leading-relaxed">
            ADASTRA ofrece servicios gastronómicos que incluyen, pero no se limitan a:
          </p>
          <div className="grid gap-4">
            <div className="bg-gray-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faUtensils} className="text-black mr-2" />
                Servicios de Restaurante
              </h5>
              <p className="text-gray-700 text-sm">Comedor en local, servicio de mesa, experiencias gastronómicas</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faCalendarAlt} className="text-black mr-2" />
                Sistema de Reservas
              </h5>
              <p className="text-gray-700 text-sm">Reservas de mesa online y telefónicas para diferentes horarios y ocasiones</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faTruck} className="text-black mr-2" />
                Pedidos para Entrega y Recogida
              </h5>
              <p className="text-gray-700 text-sm">Servicio de delivery y take-away con menú completo disponible</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faStar} className="text-black mr-2" />
                Eventos Especiales
              </h5>
              <p className="text-gray-700 text-sm">Organización de celebraciones privadas, cenas de negocios y eventos corporativos</p>
            </div>
          </div>
          <div className="bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-500">
            <p className="font-sans text-yellow-800 text-sm">
              <strong>Importante:</strong> Nos reservamos el derecho de modificar, suspender o discontinuar 
              cualquier servicio en cualquier momento sin previo aviso.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'reservas',
      title: 'Política de Reservas y Cancelaciones',
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Reservas de Mesa</h4>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Las reservas están sujetas a disponibilidad y confirmación por parte de ADASTRA</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Se requiere información de contacto válida para procesar la reserva</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Las mesas se mantienen reservadas por 15 minutos después de la hora confirmada</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Para grupos de 12 o más personas, se requiere depósito</span>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Cancelaciones</h4>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Cancelaciones gratuitas hasta 2 horas antes de la reserva</span>
              </li>
              {/* Texto eliminado según solicitud */}
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Para eventos especiales, aplican términos específicos de cancelación</span>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 'pedidos-pagos',
      title: 'Pedidos, Pagos y Facturación',
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Procesamiento de Pedidos</h4>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Todos los pedidos están sujetos a confirmación y disponibilidad de ingredientes</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Los precios mostrados pueden variar según disponibilidad de temporada</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Los tiempos de entrega son estimados y pueden variar según demanda</span>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Métodos de Pago</h4>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-gray-50 p-4 rounded-lg">
                <h5 className="font-semibold text-gray-900 mb-2">
                  <FontAwesomeIcon icon={faCreditCard} className="text-black mr-2" />
                  Pagos Aceptados
                </h5>
                <ul className="text-gray-700 text-sm space-y-1">
                  <li>• Tarjetas de crédito y débito</li>
                  <li>• PayPal y wallets digitales</li>
                  <li>• Efectivo (solo en local)</li>
                  <li>• Transferencias bancarias</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <h5 className="font-semibold text-gray-900 mb-2">
                  <FontAwesomeIcon icon={faLock} className="text-black mr-2" />
                  Seguridad
                </h5>
                <ul className="text-gray-700 text-sm space-y-1">
                  <li>• Procesamiento encriptado SSL</li>
                  <li>• Cumplimiento PCI DSS</li>
                  <li>• No almacenamos datos de tarjetas</li>
                  <li>• Verificación de transacciones</li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Cargos Adicionales</h4>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Servicio de entrega: $10.00 dentro del área de cobertura</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Los impuestos aplicables se agregan según legislación local</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>La propina es opcional y se puede agregar al momento del pago</span>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 'devoluciones',
      title: 'Política de Devoluciones y Reembolsos',
      content: (
        <div className="space-y-6">
          <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
            <p className="font-sans text-blue-800">
              <strong>Nuestra garantía:</strong> Su satisfacción es nuestra prioridad. 
              Si no está completamente satisfecho con su experiencia, háganoslo saber inmediatamente.
            </p>
          </div>
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Casos de Reembolso</h4>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Problemas con la calidad de los alimentos reportados durante la comida</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Errores en los pedidos no causados por información incorrecta del cliente</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Cancelaciones de nuestra parte por fuerza mayor o circunstancias imprevistas</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Problemas técnicos que impidan la prestación del servicio</span>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Proceso de Reembolso</h4>
            <div className="space-y-3">
              <div className="bg-gray-50 p-3 rounded-lg">
                <strong className="text-gray-900">1. Notificación:</strong>
                <span className="text-gray-700 ml-2">Contacte a nuestro equipo dentro de 24 horas del incidente</span>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg">
                <strong className="text-gray-900">2. Evaluación:</strong>
                <span className="text-gray-700 ml-2">Revisaremos su caso y determinaremos la solución apropiada</span>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg">
                <strong className="text-gray-900">3. Resolución:</strong>
                <span className="text-gray-700 ml-2">Procesaremos reembolsos dentro de 5-7 días hábiles</span>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 'responsabilidad',
      title: 'Limitaciones de Responsabilidad',
      content: (
        <div className="space-y-6">
          <div className="bg-red-50 p-4 rounded-lg border-l-4 border-red-500">
            <p className="font-sans text-red-800 font-medium flex items-start">
              <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2 mt-1 flex-shrink-0" />
              Es importante que lea y entienda estas limitaciones antes de utilizar nuestros servicios.
            </p>
          </div>
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Limitaciones Generales</h4>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>ADASTRA no será responsable por daños indirectos, incidentales o consecuentes</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Nuestra responsabilidad se limita al costo del servicio proporcionado</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>No garantizamos disponibilidad ininterrumpida de nuestros servicios online</span>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Alergias y Restricciones Alimentarias</h4>
            <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
              <p className="text-yellow-800 text-sm leading-relaxed">
                <strong>Importante:</strong> Aunque hacemos nuestro mejor esfuerzo para accommodar 
                alergias y restricciones dietéticas, no podemos garantizar un ambiente completamente 
                libre de alérgenos. Los clientes con alergias severas deben informarnos e 
                <strong> asumen la responsabilidad</strong> de evaluar la seguridad de nuestros platos.
              </p>
            </div>
          </div>
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Fuerza Mayor</h4>
            <p className="text-gray-700 leading-relaxed">
              No seremos responsables por incumplimientos debido a eventos fuera de nuestro control, 
              incluyendo pero no limitándose a: desastres naturales, pandemias, regulaciones 
              gubernamentales, fallas de servicios públicos, o circunstancias imprevistas.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'propiedad',
      title: 'Propiedad Intelectual',
      content: (
        <div className="space-y-6">
          <p className="font-sans text-lg text-gray-700 leading-relaxed">
            Todo el contenido de nuestro sitio web, restaurante y materiales está protegido por derechos de propiedad intelectual.
          </p>
          <div className="grid gap-4">
            <div className="bg-gray-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faTag} className="text-black mr-2" />
                Marca y Logo
              </h5>
              <p className="text-gray-700 text-sm">La marca ADASTRA, logotipos y elementos visuales son propiedad exclusiva del restaurante</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faFileAlt} className="text-black mr-2" />
                Contenido del Sitio
              </h5>
              <p className="text-gray-700 text-sm">Textos, imágenes, videos y diseño están protegidos por derechos de autor</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faUtensils} className="text-black mr-2" />
                Recetas y Menús
              </h5>
              <p className="text-gray-700 text-sm">Nuestras recetas originales y presentaciones son propiedad intelectual de ADASTRA</p>
            </div>
          </div>
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Uso Permitido</h4>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Uso personal y no comercial del sitio web</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Compartir experiencias en redes sociales con atribución apropiada</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Tomar fotografías para uso personal durante su visita</span>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 'modificaciones',
      title: 'Modificaciones de los Términos',
      content: (
        <div className="space-y-6">
          <p className="font-sans text-lg text-gray-700 leading-relaxed">
            ADASTRA se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento 
            para reflejar cambios en nuestros servicios, regulaciones legales o prácticas comerciales.
          </p>
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Proceso de Notificación</h4>
            <div className="space-y-3">
              <div className="bg-gray-50 p-3 rounded-lg">
                <strong className="text-gray-900">Cambios Menores:</strong>
                <span className="text-gray-700 ml-2">Actualizaciones en el sitio web con fecha de modificación</span>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg">
                <strong className="text-gray-900">Cambios Significativos:</strong>
                <span className="text-gray-700 ml-2">Notificación por email con 30 días de anticipación</span>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg">
                <strong className="text-gray-900">Cambios Urgentes:</strong>
                <span className="text-gray-700 ml-2">Notificación inmediata por razones legales o de seguridad</span>
              </div>
            </div>
          </div>
          <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
            <p className="font-sans text-blue-800 text-sm">
              <strong>Su continuidad en el uso de nuestros servicios</strong> después de cualquier 
              modificación constituye su aceptación de los nuevos términos.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'ley-contacto',
      title: 'Ley Aplicable y Contacto',
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Jurisdicción Legal</h4>
            <p className="text-gray-700 leading-relaxed">
              Estos Términos y Condiciones se rigen por las leyes de la República de Cuba. 
              Cualquier disputa que surja en relación con estos términos será resuelta en los tribunales 
              competentes de La Habana, Habana Vieja, Cuba.
            </p>
          </div>
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Resolución de Disputas</h4>
            <div className="space-y-3">
              <div className="bg-gray-50 p-3 rounded-lg">
                <strong className="text-gray-900">1. Comunicación Directa:</strong>
                <span className="text-gray-700 ml-2">Contacte nuestro servicio al cliente primero</span>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg">
                <strong className="text-gray-900">2. Mediación:</strong>
                <span className="text-gray-700 ml-2">Intentaremos resolver disputas através de mediación</span>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg">
                <strong className="text-gray-900">3. Arbitraje:</strong>
                <span className="text-gray-700 ml-2">Como último recurso, através de arbitraje vinculante</span>
              </div>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
              <h4 className="font-sans text-xl font-semibold text-gray-900 mb-4">Contacto Legal</h4>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <FontAwesomeIcon icon={faEnvelope} className="text-green-600" />
                  <span className="text-gray-700">legal@adastra-restaurant.com</span>
                </div>
                <div className="flex items-center space-x-3">
                  <FontAwesomeIcon icon={faPhone} className="text-green-600" />
                  <span className="text-gray-700">+53 6351 8498</span>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
              <h4 className="font-sans text-xl font-semibold text-gray-900 mb-4">Información Legal</h4>
              <div className="space-y-2 text-sm text-gray-700">
                <p><strong>Razón Social:</strong> ADASTRA Restaurant S.A.</p>
                <p><strong>Registro:</strong> Registro Mercantil de La Habana</p>
                <p><strong>Licencia:</strong> Restaurante y Bar #HV-2024-0892</p>
                <p><strong>Domicilio Legal:</strong> Habana Vieja, La Habana, Cuba</p>
              </div>
            </div>
          </div>
        </div>
      )
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-black pt-60 pb-48">
        <div className="container-custom max-w-4xl mx-auto px-6 text-center">
          <h1 className="font-sans text-4xl md:text-5xl font-light text-white mb-6">
            Términos y <span className="font-normal italic text-green-400">Condiciones</span>
          </h1>
          <p className="font-sans text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            Las reglas que rigen nuestra relación y garantizan una experiencia excepcional para todos.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20">
        <div className="container-custom max-w-4xl mx-auto px-6">
          <div className="space-y-6">
            {termssections.map((section) => (
              <div 
                key={section.id} 
                className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden"
              >
                <button
                  onClick={() => toggleSection(section.id)}
                  className="w-full px-8 py-6 text-left hover:bg-gray-50 transition-colors duration-200 flex items-center justify-between"
                >
                  <h3 className="font-sans text-xl md:text-2xl font-light text-gray-900">
                    {section.title}
                  </h3>
                  <FontAwesomeIcon 
                    icon={openSection === section.id ? faChevronUp : faChevronDown} 
                    className="text-gray-500 transition-transform duration-200"
                  />
                </button>
                
                {openSection === section.id && (
                  <div className="px-8 pb-8 border-t border-gray-100">
                    <div className="pt-6">
                      {section.content}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div className="mt-16 text-center">
            <div className="bg-green-600 rounded-2xl p-8 text-white">
              <h3 className="font-sans text-2xl md:text-3xl font-light mb-4">
                ¿Preguntas sobre los <span className="font-normal italic">Términos</span>?
              </h3>
              <p className="font-sans text-lg text-green-100 mb-6">
                Nuestro equipo legal está disponible para aclarar cualquier duda sobre estos términos y condiciones.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a 
                  href="mailto:legal@adastra-restaurant.com"
                  className="bg-white text-green-600 font-semibold py-3 px-8 rounded-xl hover:bg-gray-100 transition-colors duration-300"
                >
                  Consulta Legal
                </a>
                <a 
                  href="tel:+5363518498"
                  className="border-2 border-white text-white font-semibold py-3 px-8 rounded-xl hover:bg-white hover:text-green-600 transition-colors duration-300"
                >
                  Llamar Ahora
                </a>
              </div>
            </div>
          </div>

          {/* Last Updated */}
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500">
              Última actualización: {new Date().toLocaleDateString('es-ES', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terminos;